import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getPluginList = state => state.whiteLabel.plugin.list;
export const getPluginActivationRequestsList = state => state.whiteLabel.pluginActivationRequests.list;
export const getPluginTerminationRequestsList = state => state.whiteLabel.pluginTerminationRequests.list;
export const getProjectConfig = state => state.data.projectConfig && state.data.projectConfig.data;

const isPluginActiveCheck = (pluginId, projectConfig) =>
  get(
    projectConfig.plugins.find(plugin => plugin.id === pluginId),
    'is_active',
    false
  );

export const isPluginActive = (pluginId, projectConfig = null) =>
  projectConfig
    ? () => isPluginActiveCheck(pluginId, projectConfig)
    : createSelector(getProjectConfig, projectConfig => isPluginActiveCheck(pluginId, projectConfig));

export const getDependantPlugins = pluginId =>
  createSelector(getPluginList, list => list.filter(({ dependent_on }) => dependent_on === pluginId));

export const isPluginActivationRequestPending = pluginId =>
  createSelector(getPluginActivationRequestsList, list => list.some(item => item.plugin.id === pluginId));

export const isPluginTerminationRequestPending = pluginId =>
  createSelector(getPluginTerminationRequestsList, list => list.some(item => item.plugin.id === pluginId));

export default {
  isPluginActive,
  getDependantPlugins,
  isPluginActivationRequestPending,
  isPluginTerminationRequestPending,
};
